import { render, staticRenderFns } from "./generate-invoice.vue?vue&type=template&id=47d89962&scoped=true&"
import script from "./generate-invoice.vue?vue&type=script&lang=js&"
export * from "./generate-invoice.vue?vue&type=script&lang=js&"
import style0 from "./generate-invoice.vue?vue&type=style&index=0&id=47d89962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d89962",
  null
  
)

export default component.exports